var _SignedByte_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
export default class SignedByte extends Number {
    constructor(value) {
        super(value);
        _SignedByte_value.set(this, void 0);
        ensureInt(value, SignedByte.minValue, SignedByte.maxValue);
        __classPrivateFieldSet(this, _SignedByte_value, value, "f");
    }
    [(_SignedByte_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _SignedByte_value, "f").valueOf() & 0x7F;
    }
    toString() {
        return this.valueOf().toString();
    }
    static parse(value) {
        const int = parseInt(value);
        return new SignedByte(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, SignedByte.minValue, SignedByte.maxValue);
            return Result.ok(new SignedByte(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 127. */
SignedByte.maxValue = 127;
/** The lowest number that can be represented. Equal to -127. */
SignedByte.minValue = -127;
